export enum Routing {
  HOME = '/',
  FORM = '/contact',
}
